import React from 'react';
import { MDBProgress, MDBProgressBar } from 'mdb-react-ui-kit';
import { MDBIcon, MDBTooltip } from "mdb-react-ui-kit";
import { formatFileSize } from '../Common';

export const ProgressBar = ({ currentSpaceUsed, maxSpace, remainingSpace }) => {

  let text =  formatFileSize(currentSpaceUsed, 'MB')+ " MB of "+formatFileSize(maxSpace, 'MB')+" MB Used";
  const currentSpaceUsedINMB = formatFileSize(currentSpaceUsed, 'MB');
  const maxSpaceINMB = formatFileSize(maxSpace, 'MB');


  const currentSpaceUsedINKB = formatFileSize(currentSpaceUsed, 'KB');
  const maxSpaceINKB = formatFileSize(maxSpace, 'KB');
  const remainingSpaceINKB = formatFileSize(remainingSpace, 'KB');

  const percentage = (currentSpaceUsedINMB / maxSpaceINMB) * 100;
  // Determine the progress class based on percentage
  let progressClass = 'bg-light'; // Default color
  if (percentage > 90) {
    progressClass = 'bg-danger'; // Red for > 90%
  } else if (percentage >= 75) {
    progressClass = 'bg-warning'; // Yellow for 75-90%
  }
  return (
    <>
      <p>Storage Used:</p>
      <div
            style={{
              width: '100%',
              textAlign: 'center',
              left: 0,
              top: '50%',
              transform: 'translateY(-50%)',
              whiteSpace: 'nowrap',
              color: '#000', // Change color for visibility if needed
            }}
          >
            {text}
            <MDBTooltip
                tag='span'
                position='top'
                title={
                    <div style={{ whiteSpace: 'normal', textAlign: 'left' }}>
                    <span>Space Used : {currentSpaceUsedINKB}</span><br />
                    <span>Space Available : {remainingSpaceINKB}</span><br />
                    <span>Max Space : {maxSpaceINKB}</span>
                  </div>
                }
                wrapperClass="progress-bar-tooltip"
                wrapperProps={{ style: { display: 'inline'} }} // Ensures the tooltip appears correctly
            >
            <MDBIcon fas icon="info-circle" style={{ marginLeft: '15px' }} />
            </MDBTooltip>
            
        </div>
      <MDBProgress height='35' style={{ position: 'relative' }} className={progressClass}>
        <MDBProgressBar
          width={percentage}
          valuemin={0}
          valuemax={100}
          className="bg-blue"
          style={{ position: 'relative' }}
        >
            {percentage} %
          
        </MDBProgressBar>
      </MDBProgress>
    </>
  );
};
